import actionTypes from "./_actions";

const _savePasture = (offlineFarms, payload) => {
    const { farmId, budgetId, blockIds, pasture, runoffCharacteristics } = payload;
    let prevPasture = {};

    return offlineFarms.map((offlineFarm) => {
        if (offlineFarm.id !== farmId) return offlineFarm;

        return {
            ...offlineFarm,
            farm: {
                ...offlineFarm.farm,
                offlineBudgets: offlineFarm.farm.offlineBudgets.map((offlineBudget) => {
                    if (offlineBudget.id !== budgetId) return offlineBudget;

                    const blocks = offlineBudget.budget.blocks.map((block) => {
                        if (!blockIds.includes(block.id)) return block;

                        prevPasture = block.pasture;

                        // Auto add/remove animals
                        if (runoffCharacteristics) {
                            let animals = block.animals || [];
                            if (animals.length === 0) {
                                (offlineBudget.budget.enterprises || [])
                                    .filter((enterprise) => enterprise.type !== "OutdoorPigs")
                                    .forEach((enterprise) => {
                                        if (!animals.some((a) => a.enterpriseId === enterprise.id)) {
                                            animals = animals.concat({
                                                enterpriseId: enterprise.id,
                                                months: [],
                                            });
                                        }
                                    });
                            }
                            return {
                                ...block,
                                runoffCharacteristics,
                                pasture: {
                                    ...pasture,
                                    topography: prevPasture ? prevPasture.topography : undefined,
                                },
                                animals,
                            };
                        } else {
                            return {
                                ...block,
                                runoffCharacteristics: null,
                                animals: [],
                                pasture: {
                                    ...pasture,
                                    topography: prevPasture ? prevPasture.topography : undefined,
                                },
                            };
                        }
                    });

                    // Tidy up any feed supplements distributed to this block
                    let feedSupplements = offlineBudget.budget.feedSupplements || [];
                    if (!runoffCharacteristics) {
                        feedSupplements = feedSupplements.map((supplement) => {
                            const destinations = (supplement.destinations || []).map((destination) => {
                                const applications = (destination.applications || []).filter((application) => !blockIds.includes(application.blockId));
                                return {
                                    ...destination,
                                    applications,
                                };
                            });
                            return {
                                ...supplement,
                                destinations: destinations.filter((d) => d.type !== "SpecifiedBlocks" || d.applications.length > 0),
                            };
                        });
                    }

                    // Tidy up cut lucerne distributions
                    if (prevPasture) {
                        if (prevPasture.pastureCategory === "Lucerne" && pasture.pastureCategory !== "Lucerne") {
                            // Pasture type changed from lucerne to something else. Move any distributed autumn cuts to spring.
                            feedSupplements = feedSupplements.map((supplement) => {
                                if (supplement.type !== "Harvested" || supplement.amountType !== "Cuts") return supplement;

                                const destinations = (supplement.destinations || []).map((destination) => {
                                    const amount = Number(destination.amount) || 0;
                                    const amountAutumn = Number(destination.amountAutumn) || 0;
                                    return {
                                        ...destination,
                                        amount: amount + amountAutumn,
                                        amountAutumn: null,
                                    };
                                });

                                return {
                                    ...supplement,
                                    destinations,
                                };
                            });
                        } else if (prevPasture.pastureCategory !== "Lucerne" && pasture.pastureCategory === "Lucerne") {
                            // Pasture type changed from something else to lucerne. Clear all distributed
                            // amounts for harvested cuts.
                            feedSupplements = feedSupplements.map((supplement) => {
                                if (supplement.type !== "Harvested" || supplement.amountType !== "Cuts") return supplement;

                                const destinations = (supplement.destinations || []).map((destination) => {
                                    return {
                                        ...destination,
                                        amount: 0,
                                        amountAutumn: 0,
                                    };
                                });

                                return {
                                    ...supplement,
                                    destinations,
                                };
                            });
                        }
                    }

                    // Tidy up any DCD distributions to this block
                    let nitrateInhibitors = offlineBudget.budget.nitrateInhibitors || [];
                    if (!runoffCharacteristics) {
                        nitrateInhibitors = nitrateInhibitors
                            .map((nitrateInhibitor) => {
                                const applications = (nitrateInhibitor.applications || []).filter((application) => !application.blockIds.some((blockId) => blockIds.includes(blockId)));
                                return {
                                    ...nitrateInhibitor,
                                    applications,
                                };
                            })
                            .filter((nitrateInhibitor) => nitrateInhibitor.applications.length > 0);
                    }

                    return {
                        ...offlineBudget,
                        isDirty: true,
                        budget: {
                            ...offlineBudget.budget,
                            blocks,
                            feedSupplements,
                            nitrateInhibitors,
                        },
                    };
                }),
            },
        };
    });
};

const reducer = (state = [], action) => {
    let offlineFarms = state;
    if (!Array.isArray(state)) {
        offlineFarms = Object.keys(state).map((item) => state[item]);
    }

    switch (action.type) {
        case actionTypes.PASTURE_SAVE:
            return _savePasture(offlineFarms, action.payload);

        default:
            return offlineFarms;
    }
};

export default reducer;
